// Manual Stimulus manifest — emailconvo maintains this file by hand
// (it is NOT auto-generated). When you add a controller, import it here and
// register it with application.register(...) below.

import { application } from './application'

import HelloController from './hello_controller'
application.register('hello', HelloController)

import PasswordToggleController from './password_toggle_controller'
application.register('password-toggle', PasswordToggleController)

import ConversationListController from './conversation_list_controller'
application.register('conversation-list', ConversationListController)

import SelectOnFocusController from './select_on_focus_controller'
application.register('select-on-focus', SelectOnFocusController)

import DraftsSelectionController from './drafts_selection_controller'
application.register('drafts-selection', DraftsSelectionController)

import ContactAutocompleteController from './contact_autocomplete_controller'
application.register('contact-autocomplete', ContactAutocompleteController)

import SendLaterController from './send_later_controller'
application.register('send-later', SendLaterController)

import EmailChipsController from './email_chips_controller'
application.register('email-chips', EmailChipsController)

import RecipientDisclosureController from './recipient_disclosure_controller'
application.register('recipient-disclosure', RecipientDisclosureController)

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import CompanyAutocompleteController from './company_autocomplete_controller'
application.register('company-autocomplete', CompanyAutocompleteController)

import ContactComboboxController from './contact_combobox_controller'
application.register('contact-combobox', ContactComboboxController)

import SegmentPreviewController from './segment_preview_controller'
application.register('segment-preview', SegmentPreviewController)

import TemplateInsertController from './template_insert_controller'
application.register('template-insert', TemplateInsertController)

import SearchConversationsController from './search_conversations_controller'
application.register('search-conversations', SearchConversationsController)
